export default __webpack_public_path__ + "static/media/long_icon_black.ae7898dd.svg";